<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M11.6838 3.05132C11.889 2.98289 12.111 2.98289 12.3162 3.05132L20 5.61257L26.6308 3.40232C26.6308 3.40232 26.6308 3.40232 26.6308 3.40232C27.7964 3.01377 29 3.88141 29 5.10995V24.7567C29 25.5315 28.5041 26.2193 27.7693 26.4644L27.7692 26.4644L20.3162 28.9487C20.111 29.0171 19.889 29.0171 19.6838 28.9487L12 26.3874L5.36922 28.5977L5.3692 28.5978C4.20354 28.9863 3 28.1186 3 26.89V7.24328C3 6.46853 3.49575 5.78065 4.23079 5.53565C4.23079 5.53565 4.2308 5.53564 4.23081 5.53564L11.6838 3.05132ZM13 24.6126L19 26.6126V7.38743L13 5.38743V24.6126ZM11 5.38743V24.6126L5 26.6126V7.38743L11 5.38743ZM4.86324 7.43302L4.86343 7.43295L4.86324 7.43302ZM21 7.38743V26.6126L27 24.6126V5.38745L21 7.38743Z"
			fill="#000"
		/>
	</svg>
</template>
